var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramLogoNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.55 0.220219L0.900006 8.32022C0.900006 8.32022 -0.0799943 8.65022 5.6955e-06 9.27022C0.0800057 9.89022 0.870006 10.1702 0.870006 10.1702L6.06001 11.9202L18.54 4.00022C18.54 4.00022 19.26 3.56022 19.23 4.00022C19.23 4.00022 19.36 4.08022 18.97 4.44022C18.58 4.80022 9.18001 13.2602 9.18001 13.2602L8.50001 19.0402C8.79001 19.1602 9.05001 18.9602 9.05001 18.9602L12.41 15.9002L17.64 19.9102C19.05 20.5302 19.57 19.2402 19.57 19.2402L23.25 0.710219C23.24 -0.519781 21.55 0.220219 21.55 0.220219Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogoNew);
export default __webpack_public_path__ + "static/media/telegram-logo-new.7cbe22f5.svg";
export { ForwardRef as ReactComponent };